import React from 'react';
import moment from 'moment';

import {
    Form,
    Input,
    Select,
    Button,
    Row,
    Col,
    message,
    Table,
    Tag
} from 'antd';

import {
    _postFinanceNotification,
    _getFinanceNotificationForOrder,
} from '../../services'

const Item = Form.Item;
const Option = Select.Option
const { TextArea } = Input

const notificationTypeDict = {
    'Refund': [
        'Item out of stock',
        'Item discontinued',
        'Buyer cancel order – long lead time',
        'Buyer cancel order – change of price',
        'Buyer cancel order – change of mind',
        'Others (Please state in remarks)'
    ],
    'Refund & Amend Invoice': [
        'Item out of stock',
        'Item discontinued',
        'Buyer cancel order – long lead time',
        'Buyer cancel order – change of price',
        'Buyer cancel order – change of mind',
        'Others (Please state in remarks)'
    ],
    'Amend Invoice': [
        'Change of quantity',
        'Replace with alternate item / with lower price',
        'Others (Please state in remarks)'
    ],
    'Issue Credit Note': [
        'Item out of stock',
        'Item discontinued',
        'Buyer cancel order – long lead time',
        'Buyer cancel order – change of price',
        'Buyer cancel order – change of mind',
        'Others (Please state in remarks)'
    ],
    'Top Up Invoice': [
        'Additional item',
        'Alternate item / model',
        'Delivery charges',
        'Others (Please state in remarks)'
    ],
    'Void': [
        'Order pushed wrongly',
        'PO cancelled',
        'Fake order',
        'Others (Please state in remarks)'
    ]
}

class NotifyFinanceForm extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            notifications: [],
            type: 'Refund',
            reason: ''
        }
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        return (
            <Row>
                {this.state.notifications.length > 0 && 
                <Col colSpan={12}>
                    {this.renderNotificationsTable()}
                </Col>}
                <Col colSpan={12}>
                    <Form className="action-form" onSubmit={this.handleSubmit}>
                        <Row type="flex" gutter={4}>
                            <Col>
                                <Item
                                    className="action-form-item"
                                    label="Type"
                                >
                                    {getFieldDecorator('type', {
                                        rules: [
                                            { required: true }
                                        ]
                                    })(
                                        this.renderTypeDropdown()
                                    )}
                                </Item>
                            </Col>
                        </Row>

                        <Row type="flex" gutter={4}>
                            <Col>
                                <Item
                                    className="action-form-item"
                                    label="Reason"
                                >
                                    {getFieldDecorator('reason', {
                                        rules: [
                                            { required: true }
                                        ]
                                    })(
                                        this.renderReasonDropdown()
                                    )}
                                </Item>
                            </Col>
                        </Row>

                        <Row>
                            <Item
                                className="action-form-item"
                                label="Remarks"
                            >
                                {getFieldDecorator('remarks', {
                                    rules: [
                                        { required: true }
                                    ]
                                })(
                                    <TextArea
                                        rows={2}
                                    />
                                )}
                            </Item>
                        </Row>
                        <Row style={{ marginTop: 8 }} type="flex" justify="end">
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                            <Button onClick={this.props.closePopover}>
                                Cancel
                            </Button>
                        </Row>
                    </Form>
                </Col>
            </Row>
        )
    }

    componentDidMount() {
        this.getFinanceNotificationForOrder()
    }

    getFinanceNotificationForOrder = () => {
        _getFinanceNotificationForOrder({cartId: this.props.cartId})
        .then(_getFinanceNotifications => {
            this.setState({
                notifications: _getFinanceNotifications.data
            })
        })
    }

    renderTypeDropdown = () => {

        return (
            <Select style={{ width: 240 }} onChange={(e) => this.setState({ type: e })}>
                {Object.keys(notificationTypeDict).map(_type => {
                    return (
                        <Option value={_type}>{_type}</Option>

                    )
                })}
            </Select>
        )
    }

    renderReasonDropdown = () => {

        const { type } = this.state

        return (
            <Select style={{ width: 350 }} onChange={(e) => this.setState({ reason: e })}>
                {notificationTypeDict[type].map(_reason => {
                    return (
                        <Option value={_reason}>{_reason}</Option>
                    )
                })}
                {/* <Option value="VOID">VOID</Option
                <Option value="AMEND_INVOICE">AMEND INVOICE</Option>
                <Option value="TOP_UP_INVOICE">TOP UP INVOICE</Option> */}
            </Select>
        )
    }

    renderNotificationsTable = () => {
        const {notifications} = this.state

        const columns = [{
            title: 'Type',
            dataIndex: 'type',
        },{
            title: 'Reason',
            dataIndex: 'reason'
        },{
            title: 'Remarks',
            dataIndex: 'remarks'
        },{
            title: 'Requested By',
            dataIndex: 'createdBy',
            render: (createdBy) => createdBy.name
        },{
            title: 'Requested On',
            dataIndex: 'dateCreated',
            render: (dateCreated) => moment(dateCreated).format('LLL')
        },{
            title: 'Status',
            dataIndex: 'status',
            render: (status) => this.renderTag(status),
        }]
        return (
            <Table
                dataSource={notifications}
                columns={columns}
                pagination={false}
                title={() => 'Previous Requests'}
                scroll={{ y: 250 }}
            />
        )
    }

    renderTag = (status) => {

        let color;

        switch(status) {
            case 'OPEN':
                color = 'orange'
                break;
            case 'COMPLETED':
                color = 'green'
                break;
            case 'REJECTED':
                color = 'red';
                break;
            default:
                color = 'orange'
        }

        return <Tag color={color}>{status}</Tag>
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {

                const { type, reason, remarks } = values

                _postFinanceNotification({
                    type,
                    reason,
                    remarks,
                    cartId: this.props.cartId,
                    offlineReferenceNumber: this.props.offlineReferenceNumber,
                    refNumber: this.props.refNumber
                })
                    .then(res => {
                        if (res.data.success) {
                            message.success("Added Notification to Finance!")
                            this.getFinanceNotificationForOrder()
                            this.props.form.resetFields()
                            this.props.closePopover()
                        } else {
                            message.error("Failed to add!")
                        }
                    })
            }
        });
    }
}

export default Form.create({})(NotifyFinanceForm);


// WEBPACK FOOTER //
// ./src/components/orders-v2/notify-finance-form.js